export default __webpack_public_path__ + "static/media/logo.921fb4fd.jpg";